module.exports = "\n<div >\nThe room is full. try again later\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /app/src/app/wb/full-room.component.html
// module id = ../../../../../src/app/wb/full-room.component.html
// module chunks = main